import { useMemo } from 'react';

export default function usePasswordValidation(
    password: string,
    confirmPassword: string,
) {
    return useMemo(
        () => [
            {
                text: 'Password must contain a lower case letter, upper case letter and number',
                condition:
                    /[a-z]/.test(password) &&
                    /[A-Z]/.test(password) &&
                    /[0-9]/.test(password),
            },
            {
                text: 'Password must contain a special character or a space',
                condition: /[\W_\s]/.test(password),
            },
            {
                text: 'Password must contain at least 8 characters',
                condition: password.length >= 8,
            },
            {
                text: 'Passwords must match',
                condition: password === confirmPassword,
            },
        ],
        [password, confirmPassword],
    );
}
